import { useMemo } from "react";

const COLORS = ["bg-primary", "bg-accent", "bg-ink", "bg-primary/70", "bg-accent/70"];

export function Confetti({ active }: { active: boolean }) {
  const pieces = useMemo(
    () =>
      Array.from({ length: 40 }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        drift: `${Math.round((Math.random() - 0.5) * 240)}px`,
        delay: Math.random() * 0.4,
        duration: 1.6 + Math.random() * 1.2,
        color: COLORS[i % COLORS.length]!,
      })),
    [active],
  );

  if (!active) return null;

  return (
    <div
      className="pointer-events-none fixed inset-0 z-50 overflow-hidden no-print"
      aria-hidden="true"
    >
      {pieces.map((p) => (
        <span
          key={p.id}
          className={`absolute top-0 h-2.5 w-1.5 rounded-sm ${p.color}`}
          style={{
            left: `${p.left}%`,
            ["--drift" as string]: p.drift,
            animation: `confetti-fall ${p.duration}s linear ${p.delay}s forwards`,
          }}
        />
      ))}
    </div>
  );
}
